import footer1 from "./1-7.png";
import footer2 from "./2-10.png";
import footer3 from "./3-10.png";
import footer4 from "./4-10.png";
import footer5 from "./5-10.png";

const footerpasadena = [footer1, footer2, footer3, footer4, footer5];

export default footerpasadena;
